import { DSDiscoveryProductsResult } from 'shared-definitions/types'
import { ApiDiscoveryProducts } from '../types.wp'
import { additionalFilterMapper } from './additionalFilterMapper'
import { imageMapper } from './imageMapper'
import { optionalLinkMapper } from './optionalLinkMapper'
import { pLinkMapper, PLinkMapperOpts } from './pLinkMapper'

export function codecDiscoveryProducts(
  input: ApiDiscoveryProducts,
  opts: PLinkMapperOpts
): DSDiscoveryProductsResult {
  return {
    applied: {
      price: {
        min: Math.floor(input?.actualMinPrice ?? input.minPrice),
        max: Math.ceil(input?.actualMaxPrice ?? input.maxPrice),
      },
    },
    priceRange: {
      min: Math.floor(input.minPrice),
      max: Math.ceil(input.maxPrice),
    },
    brands: input.actual_brands.flatMap(brand => {
      if (!brand) {
        return []
      }
      return {
        id: brand.id.toString(),
        title: brand.name,
        featured: brand.popular,
      }
    }),
    additionalFiltersMod: input.additional_filters?.map(additionalFilterMapper) ?? null,
    list: {
      resource: 'paginated-list',
      perPage: input.items_per_page,
      currentPage: input.current_page,
      totalItems: input.total_items,
      items: input.items.map(item => ({
        category: item.category ?? '',
        brand: item.brand ?? '',
        msrp: item.msrp,
        id: item.uniq_id,
        pLinkEdit: optionalLinkMapper(item.edit_url ?? undefined),
        pLinkRequestUpdate: optionalLinkMapper(item.update_request_url ?? undefined),
        button: {
          label: 'Read full review',
          pLink: item.review_url ? pLinkMapper(item.review_url, opts) : { href: '' },
        },
        title: item.name,
        badges: item.badges.flatMap(badge => {
          if (badge.image.length) {
            return badge.image.flatMap(image => {
              const mapped = imageMapper(image, opts)
              if (!mapped) {
                return []
              }
              return mapped
            })
          }
          return []
        }),
        image: item.image ? imageMapper({ src: item.image }, opts) : null,
        rating: {
          our: item.rating ? { label: 'Sound guys', score: item.rating } : null,
          user: item.overall_user_rating
            ? { label: 'Users', score: item.overall_user_rating }
            : null,
        },
        tags: [], // temporary do not use them
      })),
    },
  }
}
